module.exports = __webpack_public_path__ + "static/media/background_1920-2.c54eef50.jpg";